import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { useLocation } from 'react-router-dom';

export default function FloatingContactWidget() {
  const location = useLocation();

  // Hide on admin dashboard pages
  if (location.pathname.includes('admin')) {
    return null;
  }

  const whatsappNumber = "919653524055";
  const phoneCallNumber = "+919653524055";
  const defaultMsg = encodeURIComponent("Hi Chaitanya Shooting Academy! I want to know more about admission and free trial session.");

  return (
    <div className="fixed z-[9990] pointer-events-none inset-x-0 bottom-6 px-4 flex items-center justify-between max-w-7xl mx-auto">
      {/* BOTTOM LEFT: WHATSAPP FLOATING BUTTON */}
      <a
        href={`https://wa.me/${whatsappNumber}?text=${defaultMsg}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        className="pointer-events-auto group relative flex items-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-white p-3.5 sm:p-4 rounded-full shadow-[0_10px_25px_rgba(37,211,102,0.4)] transition-all duration-300 transform hover:scale-105 active:scale-95"
      >
        <span className="relative flex h-3 w-3 -mr-1">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
        </span>
        <MessageCircle size={24} className="fill-white stroke-none sm:w-6 sm:h-6" />
        <span className="hidden md:inline font-bold text-xs uppercase tracking-wider pr-1">
          WhatsApp Us
        </span>
        {/* Tooltip for desktop */}
        <span className="absolute left-full ml-3 top-1/2 -translate-y-1/2 bg-zinc-900 text-white text-[11px] font-bold py-1.5 px-3 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap shadow-xl border border-white/10 hidden sm:block">
          Chat on WhatsApp
        </span>
      </a>

      {/* BOTTOM RIGHT: PHONE CALL FLOATING BUTTON */}
      <a
        href={`tel:${phoneCallNumber}`}
        aria-label="Call Academy"
        className="pointer-events-auto group relative flex items-center gap-3 bg-[#0066FF] hover:bg-[#0052cc] text-white p-3.5 sm:p-4 rounded-full shadow-[0_10px_25px_rgba(0,102,255,0.4)] transition-all duration-300 transform hover:scale-105 active:scale-95"
      >
        <span className="hidden md:inline font-bold text-xs uppercase tracking-wider pl-1">
          Call Now
        </span>
        <Phone size={24} className="fill-white stroke-none sm:w-6 sm:h-6" />
        {/* Tooltip for desktop */}
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-zinc-900 text-white text-[11px] font-bold py-1.5 px-3 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap shadow-xl border border-white/10 hidden sm:block">
          +91 96535 24055
        </span>
      </a>
    </div>
  );
}
